import React from 'react';
import { Flex, Text, Stack, Link, Image,
  Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon
 } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import chBanner from '../Resources/Images/Banners/FAQ_banner_BG.png';
import CenterGuideBrick from '../Components/Common/CenterGuideBrick';
import BannerBar from '../Components/Common/BannerBar';

const FAQPage1: React.FC = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const diplomaFAQ: string[] = t('diplomaFAQ');

  return (
    <Stack w='100%' minH='84vh' direction='column' align='center'>
      {/*<Image w='100%' maxH='301px' objectFit='cover' src={i18n.language === 'zh' ? chBanner : enBanner} alt='常見問題-大專學位證書'/>*/}
      {BannerBar(t('banner.FAQ1'), chBanner)}
      <Flex w='85%' h='100%' py='32px' direction='column'>
        <CenterGuideBrick/>
              <Text mb='24px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='white'>
                {t('diplomaType')[0]}
              </Text>
              <Text mb='24px' fontSize='24px' fontWeight='700' lineHeight='133%' letterSpacing='0.24px' color='primary.light'>
                {t('diplomaType')[0]}
              </Text>
              <Accordion allowMultiple allowToggle>
                {diplomaFAQ.map((content: string, index: number) => 
                  <AccordionItem key={index} py='6px' color='text.main' borderBottom='none'>
                    <AccordionButton>
                      <Text as='span' flex='1' textAlign='left' textStyle='semibold_lg'>
                        Q{index + 1}{i18n.language === 'zh' ? '：' : ': '}{content[0]}
                      </Text>
                      <AccordionIcon boxSize='24px' color='primary.light' />
                    </AccordionButton>
                    <AccordionPanel pb={4} textStyle='normal_md'>
                      A{i18n.language === 'zh' ? '：' : ': '}
                      {content[1].split('\n').map((ans: string, idx: number) => {
                          const linkWord = t('navbar.issuanceUnits').toLocaleLowerCase();
                          if (ans.includes(linkWord)) {
                            const substr = ans.split(linkWord);
                            return (
                              <Text>{substr[0]}<Link color='#00A2AE' textDecoration='underline' onClick={() => history.push('/school')}>{linkWord}</Link>{substr[1]}</Text>
                            )
                          }
                          return <Text key={idx} color='primary.dark' textStyle='normal_md'>{ans}</Text>;
                        })}
                    </AccordionPanel>
                  </AccordionItem>
                )}
              </Accordion>
      </Flex>
    </Stack>
  )
};

export default FAQPage1;
